import { TemplateRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import { MODAL_CONFIG } from '../../../services/constant';
import { TranslateService } from '@ngx-translate/core';
var ProfileListDetailComponent = (function () {
    function ProfileListDetailComponent(apiService, modalService, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.translate = translate;
        this.user = {};
        this.groups = [];
        this.companyGroups = [];
        this.title = '';
        this.createMode = false;
        this.errorMessage = null;
        this.errorMsgForShow = null;
        this.errorMsgForShows = null;
        this.passwordPlaceHolder = '';
        this.parent = null;
        this.checkUser = false;
        this.department = {};
        this.allSellerBranches = [];
        this.sellerBranchChoices = [];
    }
    ProfileListDetailComponent.prototype.open = function (parent, selectedUser) {
        this.parent = parent;
        this.errorMessage = null;
        if (selectedUser) {
            this.user = _.cloneDeep(selectedUser);
            this.user.group = this.user.group.id;
            delete this.user.status;
            this.createMode = false;
            this.checkUser = true;
            this.title = this.translate.instant('PROFILE.LIST.MODAL.TITLE') + ' : ' + this.user.username;
            this.passwordPlaceHolder = '(' + this.translate.instant('PROFILE.LIST.MODAL.PASSWORD-PLACEHOLDER') + ')';
            this.filterBranches();
        }
        else {
            this.user = {
                group: this.groups[0]['value'],
                company_group_id: [],
                branches: [],
                department_id: []
            };
            this.createMode = true;
            this.checkUser = false;
            this.title = this.translate.instant('PROFILE.LIST.MODAL.ADD-USER');
            this.passwordPlaceHolder = this.translate.instant('PROFILE.LIST.MODAL.PASSWORD');
        }
        this.modalRef = this.modalService.show(this.modalTemplate, MODAL_CONFIG);
    };
    ProfileListDetailComponent.prototype.ngOnInit = function () {
        this.loadGroups();
        this.loadCompanyGroups();
        this.loadDepartment();
        this.loadSellerBranches();
    };
    ProfileListDetailComponent.prototype.loadSellerBranches = function () {
        var _this = this;
        this.sellerBranchChoices = [];
        this.apiService.getDropdownBranch().subscribe(function (sellerBranches) {
            _this.allSellerBranches = sellerBranches;
        });
    };
    ProfileListDetailComponent.prototype.filterBranches = function () {
        var selectedCompanyGroup = new Set(this.user.company_group_id);
        this.sellerBranchChoices = this.allSellerBranches
            .filter(function (item) { return selectedCompanyGroup.has(item.company_group_id); })
            .map(function (item) { return ({ label: item.full_name, value: item.id }); });
        this.removeInvalidBranches();
    };
    ProfileListDetailComponent.prototype.removeInvalidBranches = function () {
        var _this = this;
        this.user.branches = this.user.branches.filter(function (branch) { return _this.sellerBranchChoices.find(function (item) { return item.value === branch; }); });
    };
    ProfileListDetailComponent.prototype.submit = function () {
        var _this = this;
        if (this.translate.currentLang === 'th') {
            var errorField = [];
            this.errorMessage = null;
            !this.user.username && errorField.push('ชื่อผู้ใช้งาน');
            !this.user.company_group_id.length && errorField.push('บริษัท');
            !this.user.branches.length && errorField.push('สาขา');
            this.createMode && !this.user.password && errorField.push('รหัสผ่าน');
            if (errorField.length > 0) {
                this.errorMessage = 'โปรดกรอก ' + errorField.join(', ') + ' ให้ถูกต้อง';
                return;
            }
        }
        else {
            var errorField = [];
            this.errorMessage = null;
            !this.user.username && errorField.push('Username');
            !this.user.company_group_id.length && errorField.push('Company');
            !this.user.branches.length && errorField.push('Branch');
            this.createMode && !this.user.password && errorField.push('Password');
            if (errorField.length > 0) {
                this.errorMessage = 'Please fill ' + errorField.join(', ') + ' correctly';
                return;
            }
        }
        var request = null;
        if (this.createMode) {
            request = this.apiService.createUser(this.user);
            var role_name = this.groups.find(function (x) { return x.value === _this.user.group; }).label;
            this.sniff('CREATE_USER', role_name + ': ' + this.user.username);
        }
        else {
            request = this.apiService.updateUser(this.user);
            this.sniff('UPDATE_USER', this.title + ' to ' + this.user.username);
        }
        request.subscribe(function (obj) {
            _this.parent.reload();
            _this.modalRef.hide();
            _this.clearData();
        }, function (error) {
            _this.checkErrorMsg(error);
        });
    };
    ProfileListDetailComponent.prototype.checkErrorMsg = function (error) {
        this.errorMessage = this.apiService.getErrorMessage(error);
    };
    ProfileListDetailComponent.prototype.clearData = function () {
        this.user = {};
        this.errorMsgForShow = null;
    };
    ProfileListDetailComponent.prototype.close = function () {
        this.modalRef.hide();
        this.clearData();
    };
    ProfileListDetailComponent.prototype.disableUser = function () {
        var _this = this;
        this.sniff('DISABLE_USER', this.user.username);
        var request = this.apiService.deleteUser(this.user);
        request.subscribe(function (obj) {
            _this.parent.reload();
            _this.modalRef.hide();
        }, function (error) {
            _this.checkErrorAllMsg(error);
        });
    };
    ProfileListDetailComponent.prototype.checkErrorAllMsg = function (error) {
        this.errorMsgForShows = this.apiService.getErrorMessage(error);
        if (this.translate.currentLang === 'en') {
            this.errorMessage = this.errorMsgForShows[0];
        }
        else {
            this.errorMessage = this.errorMsgForShows[1];
        }
    };
    ProfileListDetailComponent.prototype.enableUser = function () {
        var _this = this;
        this.sniff('ENABLE_USER', this.user.username);
        this.user.is_active = true;
        var request = this.apiService.updateUser(this.user);
        request.subscribe(function (obj) {
            _this.parent.reload();
            _this.modalRef.hide();
        }, function (error) {
            _this.errorMessage = _this.apiService.getErrorMessage(error);
        });
    };
    ProfileListDetailComponent.prototype.loadGroups = function () {
        var _this = this;
        this.groups = [];
        var params = {
            source: 'profile'
        };
        this.apiService.getRoles(params).subscribe(function (groups) {
            _.forEach(groups, function (group) {
                _this.groups.push({
                    'label': group['name'],
                    'value': group['id']
                });
            });
        }, function (error) {
            console.log('error', error);
        });
    };
    ProfileListDetailComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'MANAGE_USERS',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    ProfileListDetailComponent.prototype.loadCompanyGroups = function () {
        var _this = this;
        this.companyGroups = [];
        this.apiService.getCompanyGroups().subscribe(function (res) {
            _.forEach(res, function (cg) {
                _this.companyGroups.push({
                    'label': cg['company_group'],
                    'value': cg['id']
                });
            });
        }, function (error) {
            console.log('error', error);
        });
    };
    ProfileListDetailComponent.prototype.loadDepartment = function () {
        var _this = this;
        this.apiService.getDepartments().subscribe(function (res) {
            if (res.length > 0) {
                if (_this.translate.currentLang === 'en') {
                    _this.department = res.map(function (department) { return ({
                        label: department.name_en,
                        value: department.id,
                    }); });
                }
                else {
                    _this.department = res.map(function (department) { return ({
                        label: department.name_th,
                        value: department.id,
                    }); });
                }
            }
        }, function (error) {
            console.log(error);
        });
    };
    return ProfileListDetailComponent;
}());
export { ProfileListDetailComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-list-detail/profile-list-detail.component.ts.pre-build-optimizer.js